import { fetchPath } from '.'
import yodaFormatter from './yodaFormatter'

const createAccountRequest = (type, { id: contactId, ...requestData }) => (
  fetchPath.run({
    path: '/yoda/api/account-requests',
    method: 'POST',
    data: {
      contactId,
      type,
      requestData,
    },
  }).then(yodaFormatter)
)

export const updateAccount = (data) => (
  createAccountRequest('update', data)
)

export const createAccount = (data) => (
  createAccountRequest('create', data)
)
